// Маленькие форматтеры дат/времени для UI. Локализуем под ru-RU — это
// дефолтный язык админки. AntD на kk нет, переводы UI идут через i18n,
// но для дат пока используем ru-RU как читаемый формат (Астана живёт в +05).

export function formatDateTime(value: string | null | undefined): string {
  if (!value) return '—';
  try {
    return new Date(value).toLocaleString('ru-RU', {
      dateStyle: 'short',
      timeStyle: 'short',
    });
  } catch {
    return String(value);
  }
}

// Разделитель тысяч (неразрывный пробел), как в дизайне: «4 820 SMS».
export function formatNumber(value: number | null | undefined): string {
  if (value === null || value === undefined || Number.isNaN(value)) return '—';
  return value.toLocaleString('ru-RU');
}

export function formatDate(value: string | null | undefined): string {
  if (!value) return '—';
  try {
    return new Date(value).toLocaleDateString('ru-RU');
  } catch {
    return String(value);
  }
}

export function formatTime(value: string | null | undefined): string {
  if (!value) return '—';
  try {
    return new Date(value).toLocaleTimeString('ru-RU', {
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return String(value);
  }
}

// Грубая «относительная» метка для журналов: «5 мин назад», «вчера», «2 нед назад».
// На M2 этого достаточно; в M3 при росте трафика можно подключить date-fns.
export function formatRelative(value: string | null | undefined): string {
  if (!value) return '—';
  const d = new Date(value).getTime();
  if (isNaN(d)) return String(value);
  const diff = Date.now() - d;
  const min = Math.round(diff / 60_000);
  if (min < 1) return 'только что';
  if (min < 60) return `${min} мин назад`;
  const hr = Math.round(min / 60);
  if (hr < 24) return `${hr} ч назад`;
  const day = Math.round(hr / 24);
  if (day === 1) return 'вчера';
  if (day < 7) return `${day} дн назад`;
  return formatDate(value);
}

/** Телефон E.164 для показа: «+7 913 985 11 35» (номера +7); остальные — как есть. */
export function formatPhone(e164: string): string {
  const m = /^\+7(\d{3})(\d{3})(\d{2})(\d{2})$/.exec(e164);
  return m ? `+7 ${m[1]} ${m[2]} ${m[3]} ${m[4]}` : e164;
}
